import { useQuery } from '@tanstack/react-query'
import { PauseCircle } from 'lucide-react'
import { apiClient } from '@/api/client'

/**
 * Orders still on hold at Day Close (F-CTRL-N72).
 *
 * A notice, never a blocker: a held cart is not a sale — no number, no kitchen
 * ticket, no money — so there is nothing to reconcile. Staging the close
 * expires them on the server (the rows stay, with close_reason = day_close),
 * and tomorrow's tills open with an empty "On hold" list. The manager just gets
 * one last chance to ring up a guest who is still waiting.
 */
export function HeldCartsDayCloseNotice() {
  const { data: held = [] } = useQuery({
    queryKey: ['counterHeldCarts'],
    queryFn: async () => {
      const r = await apiClient.listHeldCarts()
      return Array.isArray(r.data) ? r.data : []
    },
    refetchInterval: 30_000,
  })

  if (held.length === 0) return null

  return (
    <div className="rounded-lg border border-amber-300 bg-amber-50 p-4 dark:border-amber-700 dark:bg-amber-950">
      <div className="flex items-start gap-3">
        <PauseCircle className="h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400" aria-hidden="true" />
        <div className="text-sm text-amber-900 dark:text-amber-200">
          <p className="font-semibold">
            {held.length} order{held.length === 1 ? ' is' : 's are'} still on hold
          </p>
          <p className="mt-1">
            Closing the day clears {held.length === 1 ? 'it' : 'them'}. Nothing was sent to the kitchen or paid, so
            no totals change — but if a guest is still waiting, resume their order at the counter first.
          </p>
        </div>
      </div>
    </div>
  )
}
